<div class="flex flex-col md:flex-row gap-4 justify-center" *transloco="let t; read 'home.calculator'">

  <div class="mt-2 w-[95%] transform transition ease-in-out"
       [ngClass]="{'w-[95%]': calculatorState === SimpleCalculatorState.Submitted, 'md:w-[70%]': calculatorState !== SimpleCalculatorState.Submitted}"
       @inOutFromRight>
    <psc-simple-calculator-map
      [orientation]="formGroup.controls['azimuth'] ? formGroup.controls['azimuth'].value : 0"
      [dataInputDone]="calculatorState === SimpleCalculatorState.Submitted"
      [colorConfig]="colorConfig"
      (locationSet)="setLocation($event)"
      (solarApiInfoNotFound)="calculatorState = SimpleCalculatorState.InputLocationData"
      (roofSegmentSelected)="roofSegmentSelected($event)"></psc-simple-calculator-map>
  </div>
  <div
    [ngClass]="{'flex-1': calculatorState !== SimpleCalculatorState.SelectLocation }"
    class="flex flex-col md:flex-row gap-10 relative">
    <form
      *ngIf="calculatorState !== SimpleCalculatorState.Submitted"
      class="flex flex-col w-full"
      [formGroup]="formGroup">

      <ng-container [ngSwitch]="calculatorState">
        <div *ngSwitchCase="SimpleCalculatorState.InputLocationData">

          <div class="{{colorConfig.textColor}} text-2xl my-4 pb-2 text-center border-b {{colorConfig.borderColor}}">
          {{ t('site_data.title') }}
          </div>

        <psc-range
          @inOutAnimation
          formControlName="tilt"
          [bgColorClass]="colorConfig.bgColor"
          [infoIconColorClass]="colorConfig.textColor"
          [tooltipArrowColorClass]="colorConfig.afterBorderTopClass"
          [sliderColorClass]="colorConfig.accentClass"
          [label]="t('tilt.title')"
          [infoText]="t('tilt.info')"
          [stepLabels]="roofTiltValues"
          [min]="0"
          [max]="45"
          [step]="1"></psc-range>

        <!-- t(home.calculator.azimuth.values.N, home.calculator.azimuth.values.NW, home.calculator.azimuth.values.W, home.calculator.azimuth.values.SW) -->
        <!-- t(home.calculator.azimuth.values.S, home.calculator.azimuth.values.SE, home.calculator.azimuth.values.E, home.calculator.azimuth.values.NE, home.calculator.azimuth.values.N) -->
        <div class="flex">
          <psc-orientation-pointer
            [pointerColorClasses]="colorConfig.borderClass"
            [textColorClass]="colorConfig.textColor"
            @inOutAnimation
            [orientation]="formGroup.controls['azimuth'].value"></psc-orientation-pointer>
          <psc-range
            class="flex-1"
            @inOutAnimation
            formControlName="azimuth"
            [bgColorClass]="colorConfig.bgColor"
            [infoIconColorClass]="colorConfig.textColor"
            [tooltipArrowColorClass]="colorConfig.afterBorderTopClass"
            [sliderColorClass]="colorConfig.accentClass"
            [label]="t('azimuth.title')"
            [infoText]="t('azimuth.info')"
            [stepLabels]="roofAzimuthValues | translateStringArray:t:'azimuth.values'"
            [min]="0"
            [max]="360"
            [step]="1"></psc-range>
        </div>

        <psc-input
          @inOutAnimation
          formControlName="area"
          [label]="t('area.title')"
          [bgColorClass]="colorConfig.bgColor"
          [infoIconColorClass]="colorConfig.textColor"
          [infoText]="t('area.info')"
          ngDefaultControl
          prefix="m2"
          type="number"></psc-input>

          <psc-button
            size="small"
            [type]="colorConfig.primaryButtonType"
            [label]="t('next')"
            [disabled]="!(formGroup.controls['tilt'].valid && formGroup.controls['azimuth'].valid && formGroup.controls['area'].valid)"
            (buttonClicked)="calculatorState = SimpleCalculatorState.ConsumptionInfo"></psc-button>
      </div>

        <div *ngSwitchCase="SimpleCalculatorState.ConsumptionInfo">
          <div class="{{colorConfig.textColor}} text-2xl my-4  pb-2 text-center border-b {{colorConfig.borderColor}}">
            {{ t('consumption-input.title') }}
          </div>

          <psc-input
            @inOutAnimation
            [bgColorClass]="colorConfig.bgColor"
            [infoIconColorClass]="colorConfig.textColor"
            formControlName="consumption_average_bill"
            [label]="t('consumption_average_bill.title')"
            prefix="EUR"
            type="number"></psc-input>

          <div class="flex justify-between gap-2">
            <psc-button
              [type]="colorConfig.secondaryButtonType"
              size="small"
              [label]="t('back')"
              (buttonClicked)="calculatorState = SimpleCalculatorState.InputLocationData"></psc-button>

            <psc-button
              size="small"
              [type]="colorConfig.primaryButtonType"
              [label]="t('submit')"
              (buttonClicked)="onSubmit()"
              [disabled]="!formGroup.valid"></psc-button>

          </div>
        </div>
      </ng-container>
    </form>

  </div>
</div>
